import { getQueryClient } from "@/services/get-query-client";
import { authenticatedFetch } from "@/services/utils/authenticatedFetch";

type UploadBlobResponse = {
  status: "OK" | "ERROR";
  response?: {
    message: string;
    blob_name: string;
    container_name: string;
    size: number;
  };
  errors?: Array<{
    message: string;
  }>;
};

export default async function uploadBlob(
  file: File,
  blobName?: string,
  metadata?: Record<string, string>
): Promise<UploadBlobResponse> {
  const queryClient = getQueryClient();
  
  const url = "/api/blob/upload";

  const formData = new FormData();
  formData.append('file', file);
  
  if (blobName) {
    formData.append('blob_name', blobName);
  }
  
  if (metadata) {
    Object.entries(metadata).forEach(([key, value]) => {
      formData.append(`metadata_${key}`, value);
    });
  }

  const response = await authenticatedFetch(url, {
    method: "POST",
    body: formData,
    headers: {} // Let browser set multipart/form-data content type automatically
  });

  if (!response.ok) {
    throw new Error(`Failed to upload blob: ${response.status}`);
  }

  const result = await response.json() as UploadBlobResponse;
  
  // Invalidate and refetch the blobs list after successful upload
  if (result.status === "OK") {
    console.log("Upload successful, invalidating blobs cache...");
    await queryClient.invalidateQueries({ queryKey: ["blobs"] });
    console.log("Blobs cache invalidated");
  }
  
  return result;
}
